export class AccountDto {
    public seq!: number;
    public email!: string;
    public name!: string;
    public uuid!: string;
}